<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{ "Add Documents " | translate }}</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content">
        <form [formGroup]="usefulDocForm" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-md-6 mt-3 mt-xl-4">
                    <label class="" class="pt-xl-2">Document Name*</label>
                    <input type="text" class="form-control" formControlName="d_n">
                    <div><mat-error *ngIf="isControlHasError('d_n','required')"> {{"This is required"|translate}}</mat-error></div>
                    <label class="mt-3">Description (optional)</label>
                    <textarea name="" id="" cols="30" rows="5" class="form-control" formControlName="d_desc"></textarea>
                </div>
                <div class="col-md-6 mt-3 mt-xl-4 pt-xl-2">
                    <mat-checkbox name="visible" formControlName="v_u">
                        <div class="text-wrap"> Visible to users in the mobile app</div>
                    </mat-checkbox>
                    <mat-checkbox name="agree" formControlName="e_u">
                        <div class="text-wrap"> Enable users to upload via the mobile app and user's view</div>

                    </mat-checkbox>
                    <p class="note-txt ps-3 ps-sm-5 ">(If disabled only owners and admins can upload documents)</p>
                </div>
            </div>
            <div class="border-class my-3 my-xl-4"></div>
            <div class="row">
                <div class="col-md-6">
                    <mat-checkbox name="agree" formControlName="s_edt">
                        <div class="text-wrap"> Set Expiry date</div>
                    </mat-checkbox>
                    <p class="note-txt ps-3 ps-sm-5 ">All entries for this document will expire at the selected date.</p>
                    <div class="in-box me-2  mt-sm-3" *ngIf="this.usefulDocForm.value.s_edt==true">
                        <input class="form-control" [matDatepicker]="expiryDate" placeholder="Select Date"
                            formControlName="dt" />
                        <mat-datepicker-toggle matIconSuffix [for]="expiryDate"></mat-datepicker-toggle>
                        <mat-datepicker #expiryDate></mat-datepicker>
                    </div>
                    <mat-error *ngIf="isControlHasError('dt','required')"> {{"This is required"|translate}}</mat-error>
                </div>
                <div class="col-md-6" *ngIf="this.usefulDocForm.value.s_edt==true">
                    <mat-checkbox name="agree" formControlName="n_u">
                        <div class="text-wrap"> Send Notification</div>
                    </mat-checkbox>
                    <p class="note-txt ps-3 ps-sm-5 ">Users will get a reminder 30, 7, and 1 day before the expiration date.</p>
                </div>
            </div>

        </form>
       
    </div>
    <div class="row">
        <div class="col-md-6 m-auto mt-3 mt-xl-5">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" (click)="onSubmit()"
                type="submit">{{ "Save" | translate }}</button>
        </div>
    </div>
</div>    